import React from 'react';

type ProgressLoaderProps = {
  progress: number; // progress percentage from 0 to 100
  height?: string; // optional height for the loader
};

const ProgressLoader: React.FC<ProgressLoaderProps> = ({
  progress,
  height = '2px',
}) => {
  return (
    <div className="w-full bg-gray-200 rounded-full h-2">
      <div
        className="bg-[#34C759] rounded-full"
        style={{ width: `${progress}%`, height }}
      ></div>
    </div>
  );
};

export default ProgressLoader;
